const states = [
  { id: "1", name: "New York" },
  { id: "2", name: "Chichago" },
  { id: "3", name: "California" },
];

export const FormFields = [
  {
    id: "locationName",
    name: "locationName",
    label: "Location Name",
    fieldType: "textField",
    type: "onInputChange",
    required: true,
    xs: 12,
    sm: 12,
  },
  {
    id: "addressLine1",
    name: "addressLine1",
    label: "Address Line1",
    fieldType: "textField",
    type: "onInputChange",
    required: true,
    xs: 12,
    sm: 6,
  },
  {
    id: "suit",
    name: "suite",
    label: "Suite",
    fieldType: "textField",
    type: "onInputChange",
    xs: 12,
    sm: 6,
  },
  {
    id: "addressLine2",
    name: "addressLine2",
    label: "Address Line2",
    fieldType: "textField",
    type: "onInputChange",
    xs: 12,
    sm: 6,
  },
  {
    id: "city",
    name: "city",
    label: "City",
    fieldType: "textField",
    type: "onInputChange",
    xs: 12,
    sm: 3,
  },
  {
    id: "state",
    name: "stateName",
    label: "State",
    fieldType: "select",
    type: "onInputChange",
    items: states,
    xs: 12,
    sm: 3,
  },
  {
    id: "zip",
    name: "zip",
    label: "Zip Code",
    fieldType: "textField",
    type: "onInputChange",
    required: true,
    xs: 12,
    sm: 3,
  },
  {
    id: "phone",
    name: "phone",
    label: "Phone No.",
    fieldType: "textField",
    type: "onInputChange",
    required: true,
    xs: 12,
    sm: 3,
  },
  {
    id: "timezone",
    name: "timezone",
    label: "Time Zone",
    fieldType: "textField",
    type: "onInputChange",
    xs: 12,
    sm: 6,
  },
  {
    id: "button",
    label: "Time Zone",
    fieldType: "button",
    xs: 12,
    sm: 3,
  },
  {
    id: "appointment",
    name: "appointment",
    label: "Appointment",
    fieldType: "chip",
    type: "onChipChange",
    xs: 12,
    sm: 6,
  },
];
